import { classNames, React } from '@digsup/core-ui';
import { Text } from '@digsup/components-text';
import PropTypes from 'prop-types';

const cx = classNames;

export const PopoverTitle = ({ children, className }) => {
  const classes = cx('c-popover__title', className);
  return (
    <Text marginBottom="none" className={classes}>
      {children}
    </Text>
  );
};

PopoverTitle.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
};

PopoverTitle.defaultProps = {};
